var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { loading } from '../../../elements/Loading';
import Report from '../components/Report';
import { toDateTime, toMoney } from '../../../helpers/Format';
var CashdeskMovements = /** @class */ (function (_super) {
    __extends(CashdeskMovements, _super);
    function CashdeskMovements(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            from: _this.props.from,
            to: _this.props.to,
            fromVisible: false,
            toVisible: false,
            filter: null
        };
        return _this;
    }
    CashdeskMovements.prototype.render = function () {
        var movements = this.props.movements || [];
        var ticketCashdesks = this.props.ticketCashdesks || [];
        console.log('ticketCashdesks: ', ticketCashdesks);
        var filtered = ticketCashdesks.reduce(function (previous, ticketCashdesk) {
            previous.push.apply(previous, ticketCashdesk.movements);
            return previous;
        }, []);
        var headers = ['type', 'date'];
        return (React.createElement(Report, { filterDate: true, header: headers, items: filtered, keyExtractor: function (item) { return new Date(item.date).toISOString(); }, format: function (items) {
                console.log('items en format: ', items);
                return items.map(function (movement) { return (__assign(__assign({}, movement), { date: toDateTime(movement.date), importe: toMoney(movement.importe) })); });
            } }));
    };
    CashdeskMovements = __decorate([
        inject('store'),
        loading(function (props) {
            console.log('props: ', props);
            return [
                props.store.reports.readTicketCashDesksFromTo(props.from, props.to).then(function (ticketCashdesks) { return ({ ticketCashdesks: ticketCashdesks }); }),
                props.store.settingCashMovementStore.read().then(function (movements) { return ({ movements: movements }); })
            ];
        }),
        observer
    ], CashdeskMovements);
    return CashdeskMovements;
}(Component));
export default CashdeskMovements;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/containers/CashdeskMovements.tsx
// module id = 1186
// module chunks = 0